import axios from "./axios";

export const getAuditHistory = async (id,type, param) => {
  try {
    if(type){
      param.type = type;
    }
    const data = await axios.get(`/api/v1/provision/audit/${id}`, {params:param});
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getActionProgress = async (id,type, param) => {
  try {
    if(type){
      param.type = type;
    }
    const data = await axios.get(`/api/v1/provision/progress/${id}`, {params:param});
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getActionStepLog = async (id, filename, type) => {
  try {
    const data = await axios.get(`/api/v1/provision/log/${id}/${filename}` + (type==""?"":`?type=${type}`));
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const downLoadActionStepLog = async (id, filename, type) => {
    const data = await axios.get(`/api/v1/provision/download/${id}/${filename}` + (type==""?"":`?type=${type}`), {responseType: 'blob'});
    return data;
};

export const getStreamingLogName = async (id, type) => {
  const data = await axios.get(`/api/v1/provision/log/streaming/${id}` + (type==""?"":`?type=${type}`));
  return data;
};
